import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
        <Path
            d="M10.0006 2C14.4188 2 18.0004 5.58187 18.0006 10C18.0006 14.4183 14.4189 18 10.0006 18C5.58248 17.9998 2.00061 14.4182 2.00061 10C2.00079 5.58198 5.58259 2.00018 10.0006 2ZM13.6207 6.38184C13.279 6.04013 12.7242 6.04013 12.3824 6.38184L6.38245 12.3818C6.04074 12.7235 6.04074 13.2784 6.38245 13.6201C6.72418 13.9615 7.27913 13.9617 7.62073 13.6201L13.6207 7.62012C13.9623 7.27852 13.9621 6.72357 13.6207 6.38184Z"
            fill={ds.colorValue.icon.warning}
        />
    </Svg>
);

export default SvgComponent;
